import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Avatar from '@divvy-web/skylab.avatar'
import Tooltip from '@divvy-web/skylab.tooltip'

import { useAuth } from '@sputnik/auth'

import styles from './styles.module.scss'

const NavigationFooter = () => {
  const [getClassName, makeTestId] = useNameFormatter('NavigationFooter')
  const { email } = useAuth()

  if (!email) {
    return null
  }

  return (
    <div
      className={`${styles[getClassName('')]} fs-mask`}
      data-testid={makeTestId('')}
    >
      <Tooltip
        dataTestId={makeTestId('tooltip')}
        disableTooltip={email.length < 20}
        html={email}
      >
        <Avatar fallbackText={email.charAt(0)}>
          <div className={styles[getClassName('user-email')]}>{email}</div>
        </Avatar>
      </Tooltip>
    </div>
  )
}

export default NavigationFooter
